import { render, staticRenderFns } from "./ques-compose.vue?vue&type=template&id=59d955c4&scoped=true"
import script from "./ques-compose.vue?vue&type=script&lang=js"
export * from "./ques-compose.vue?vue&type=script&lang=js"
import style0 from "./ques-compose.vue?vue&type=style&index=0&id=59d955c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d955c4",
  null
  
)

export default component.exports